<div class="tabs-container" [hidden]="showingDetail">
  <div class="clearfix">
    <button class="button" (click)="create()">Create Work Order</button>

    <label for="completed" class="float-right">
      <input class="no-margin vertical-align-middle" type="checkbox" id="completed" [(ngModel)]="showCompletedItems" (change)="onCompletedChange()">
      Show completed tasks
    </label>
  </div>
  <!-- Allowing a refresh button might be helpful if we take the time to make it look nicer -->
  <!-- <div><a (click)="refreshData()">Refresh</a></div> -->

  <tabs (tabClicked)="onTabClicked()">
    <tab title="Assigned to Me">
      <ag-grid-angular class="data-grid " [rowData]="data" [gridOptions]="assignToMeGridOptions" [attr.aria-label]="widgetTitle + ' - Assigned to Me'">
      </ag-grid-angular>
    </tab>

    <tab title="Assigned to Group">
      <ag-grid-angular class="data-grid " [rowData]="data" [gridOptions]="assignToGroupGridOptions" [attr.aria-label]="widgetTitle + ' - Assigned to Group'">
      </ag-grid-angular>
    </tab>

    <tab title="Assigned by Me">
      <ag-grid-angular class="data-grid " [rowData]="data" [gridOptions]="assignByMeGridOptions" [attr.aria-label]="widgetTitle + ' - Assigned by Me'">
      </ag-grid-angular>
    </tab>
  </tabs>
</div>

@if (showingDetail && selectedItem) {
  <div class="detail">
    <a class="small-font-size" (click)="hideDetail()">&laquo; Back</a>
    <work-order-detail [selectedItem]="selectedItem" [standAlone]="false" (completed)="markComplete($event)"></work-order-detail>
  </div>
}
